import {useEffect, useState} from 'react';
import {useLoaderData, useNavigation, useParams} from "react-router-dom";

import {isMobile} from "react-device-detect";

import {setPageTitle} from '../../../../../Helpers/router';

import PreloaderTable from '../../../../../Components/Preloaders/PreloaderTable';

import TitleWidget from '../../../../Content/Widgets/Title';
import TableView from '../../../../Content/Widgets/Table';

import {useBackdropPreloaderStore} from '../../../../../Stores/backdropPreloader';

import './index.scss';

export default () => {
    const initData = useLoaderData();
    let {tid} = useParams();

    const navigation = useNavigation();

    const {hideBackdropPreloader} = useBackdropPreloaderStore(); // showBackdropPreloader

    const [content, setContent] = useState();
    const [history, setHistory] = useState();
    const [tableOptions, setTableOptions] = useState();
    const [fields, setFields] = useState()

    useEffect(() => {
        setTableOptions(isMobile ? {
            visible: ['text'],
            hidden: [],
            noHeaders: true,
            unfolded: true,
        } : {
            visible: ['text'],
            hidden: [],
            noHeaders: true,
            unfolded: true,
        })

        setPageTitle('Чати ' + tid)
    }, [])

    useEffect(() => {
        if (navigation.state === 'idle') {
            setFields({
                text: {
                        type: 'telegram-user-chats',
                        placeholder: 'Чати',
                        extraData: initData.extraData
                    },
                })
            setHistory(initData)
            setContent({title: 'Чати ' + tid})    
            hideBackdropPreloader()
        }
    }, [navigation])

    // const selectClasses = (data) => {
    //     return data?._code
    //         ? 'tr_' + data?._code.replace(':', '_')
    //         : '';
    // }

    const config = {templateOptions: {}}

    return <div id="Content" className='Content'>
            <div className='TelegramUserChats'>
                {!fields && <PreloaderTable/>}

                {fields && content && <TitleWidget permits={{}} content={content} config={config} />}

                {fields && history && <TableView
                    showPreloader={!history?.list}
                    content={history}
                    fields={fields}
                    showPagination={true}
                    tableOptions={tableOptions}
                    actions={false}
                    // selectClasses={selectClasses}
                />}
            </div>
            {/* <UserAdminActions /> */}
        </div>
}
